<div flex class="fixedButons">
  <ion-button color="buttonPrimary" (click)="goToAssign()"> {{'SIGNATURE.TO_SIGN' | translate}} </ion-button>
  <ion-button
    color="buttonPrimary"
    (click)="share(witnessSignatureData?.witnessSignature?.surveyReportLink, false, $event)"
  >
    {{'SIGNATURE.TO_VIEW_REPORT' | translate}}
  </ion-button>
</div>
<ng-template #Retry>
  <div height-100vh margin-auto flex class="ion-align-items-center ion-justify-content-start ion-text-center">
    <section>
      <h1 class="ion-text-center" regular> {{'SIGNATURE.WE_ARE_ISSUING_THE_INSPECTION' | translate}} </h1>
      <h2 class="ion-text-center" margin regular> {{'SIGNATURE.WAIT_A_FEW_SECONDS_AND_TRY' | translate}} </h2>
      <ion-button class="ion-margin" color="buttonPrimary" (click)="updateElements()">
        {{'SIGNATURE.TRY_AGAIN' | translate}}
      </ion-button>
    </section>
  </div>
</ng-template>
